export * from './text-component-config.interface';
export * from './text-mode.enum';
export * from '../shared/typography/text-align.enum';
export * from '../shared/typography/text-decoration.enum';
export * from '../shared/typography/font-weight.enum';
